
export default {
    
    name: 'programas',
    component: () => import(/* webpackChunkName: "Campus" */ '@/modules/sievi/layouts/SieviLayout.vue'),
    children: [
        {
            path: '',
            name: 'programs.home',
            component: () => import(/* webpackChunkName: "Campus-list" */ '@/modules/sievi/views/administrador/programs/List.vue'),
        },
        {
            path: 'responsable/:id/:campusId/:hfsId',
            name: 'programs.responsable',
            component: () => import(/* webpackChunkName: "Programs-list" */ '@/modules/sievi/views/responsable/programa/List.vue'),
            props: ( route ) => {
                return {
                    id: Number(route.params.id),
                    campusId: Number(route.params.campusId),
                    hfsId: Number(route.params.hfsId),
                }
            }
        },
        {
            path: 'responsable/:id/:campusId/:hfsId/:programId',
            name: 'programs.teacher.responsable',
            component: () => import(/* webpackChunkName: "Programs-teachers" */ '@/modules/sievi/views/responsable/docentes/List.vue'),
            props: ( route ) => {
                return {
                    id: Number(route.params.id),
                    campusId: Number(route.params.campusId),
                    hfsId: Number(route.params.hfsId),
                    programId: Number(route.params.programId)
                }
            }
        },
        {
            path: 'auditor/:campusId',
            name: 'programs.auditor',
            component: () => import(/* webpackChunkName: "Programs-list" */ '@/modules/sievi/views/auditor/programa/List.vue'),
            props: ( route ) => {
                return {
                    campusId: Number(route.params.campusId),
                }
            }
        },
        {
            path: 'auditor/:campusId/:programId',
            name: 'programs.teacher.auditor',
            component: () => import(/* webpackChunkName: "Programs-teachers" */ '@/modules/sievi/views/auditor/docentes/List.vue'),
            props: ( route ) => {
                return {
                    campusId: Number(route.params.campusId),
                    programId: Number(route.params.programId)
                }
            }
        },
    ],

}